import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { catchError, from, of, Subscription, switchMap } from 'rxjs';

import { UserService } from '../../services/user.service';

// Public or sign-up pages, and the onboarding itself: the reminder has no place there
const NO_ONBOARDING_BANNER_PREFIXES = ['/onboarding', '/register', '/login', '/reset-confirm', '/mes-commandes', '/mon-rendez-vous'];

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss']
})
export class AdminLayoutComponent implements OnInit, OnDestroy {

    public display: boolean;
    public needsOnboarding = false;
    public onboardingBannerAllowed = false;
    private onboardingSubscription?: Subscription;

    constructor(public userService: UserService, private router: Router) {
        this.display = false;

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                console.log('ADMIN LAYOUT ROUTER EVENT : ', event);

                if (event.url.startsWith("/register")) {
                    this.display = false;
                } else if (event.url.startsWith("/login")) {
                    this.display = false;
                } else if (event.url.startsWith("/reset-confirm")) {
                    this.display = false;
                } else if (event.url.startsWith("/mes-commandes")) {
                    this.display = false;
                } else if (event.url.startsWith("/mon-rendez-vous")) {
                    this.display = false;
                }else {
                    this.display = true;
                }

                const url = event.urlAfterRedirects;
                this.onboardingBannerAllowed = !NO_ONBOARDING_BANNER_PREFIXES.some(prefix => url.startsWith(prefix));
            }
        });
    }

    ngOnInit() {
        // Live: the banner goes as soon as the onboarding is finished
        this.onboardingSubscription = this.userService.getUserAuthState().pipe(
            switchMap(authState => authState === UserService.AuthStatus.LoggedIn && this.userService.currentUserReadOnly
                ? this.userService.currentUserReadOnly.pipe(
                    switchMap(userReadOnly => from(this.userService.needsOnboarding(userReadOnly))),
                    catchError(() => of(false)))
                : of(false))
        ).subscribe(needsOnboarding => { this.needsOnboarding = needsOnboarding; });
    }

    ngOnDestroy() {
        this.onboardingSubscription?.unsubscribe();
    }
}
